import React, {useState, useCallback, useRef} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ISA315ScotItApplicationBodyListItem from './ISA315ScotItApplicationBodyListItem';
import {useCanvasFormMetadata} from '../../../../../../../util/customHooks';
import {ViewEntityContainer} from '../ViewEntities/index';
import BodySpecialFetchContainer from '../BodySpecialFetchContainer';
import CreateEditSCOTModalWrapper from '../../../../../EntityCrud/CreateEditSCOTModalWrapper';
import { clientSideEventNames } from '../../../../../../../util/uiconstants';

export default function ISA315ScotItApplicationBodyList({
	className,
	allIds,
	engagementId,
	documentId,
	documentEngagementId,
	bodyId,
	bodyTypeId,
	forceUpdateCallback
}) {
	const {isTargetEngagement} = useCanvasFormMetadata();

	const [showModal, setShowModal] = useState(false);
	const [scotId, setScotId] = useState();
	const [viewControlContainerProps, setViewControlContainerProps] = useState({});

	const viewControlModalRef = useRef();

	const onDropdownOptionClick = (clickArgs) => {
		setScotId(clickArgs);
		setShowModal(!showModal);
	};

	const onViewControlClick = useCallback(
		(clickArgs) => {
			if (viewControlModalRef.current.toggleModal) {
				setViewControlContainerProps(clickArgs);
				viewControlModalRef.current.toggleModal();
			}
		},
		[viewControlModalRef]
	);

	return (
		<BodySpecialFetchContainer className="StyledISA315ScotItApplicationBodyListWrapper customScrollbar">
			<CreateEditSCOTModalWrapper
				isEdit
				entityId={scotId}
				showModal={showModal}
				setShowModal={setShowModal}
				onSave={() => {
					window.dispatchEvent(new CustomEvent(clientSideEventNames.getValidations));
				}}
			/>
			<ViewEntityContainer
				{...viewControlContainerProps}
				engagementId={engagementId}
				documentId={documentId}
				documentEngagementId={documentEngagementId}
				bodyId={bodyId}
				ref={viewControlModalRef}
			/>
			<StyledISA315ScotItApplicationBodyList className={className}>
				{allIds.map((id) => (
					<ISA315ScotItApplicationBodyListItem
						scotId={id}
						bodyId={bodyId}
						key={id}
						isTargetEngagement={isTargetEngagement}
						onDropdownOptionClick={onDropdownOptionClick}
						onViewControlClick={onViewControlClick}
					/>
				))}
			</StyledISA315ScotItApplicationBodyList>
		</BodySpecialFetchContainer>
	);
}

ISA315ScotItApplicationBodyList.propTypes = {
	className: PropTypes.string,
	allIds: PropTypes.arrayOf(PropTypes.number)
};

ISA315ScotItApplicationBodyList.defaultProps = {
	className: 'StyledISA315ScotItApplicationBodyList isa315-scot-itapplication-body-list'
};

const StyledISA315ScotItApplicationBodyList = styled.section``;
